import { Asset } from '../../features/AssetGrid/utils/types';

import { addNamespace } from '../../features/AssetGrid/utils/actions';
import { createAction } from '@reduxjs/toolkit';
import { RequestStatus } from '../../features/AssetGrid/types/asset.types';

export const getAsset = createAction<string>(addNamespace('asset/getAsset'));
export const getAssetResolved = createAction<Asset>(
	addNamespace('asset/getAsset/resolved'),
);
export const getAssetRejected = createAction(
	addNamespace('asset/getAsset/rejected'),
);

export const getAssetWithExtendedData = createAction<string>(
	addNamespace('asset/getAssetWithExtendedData'),
);

export const setMultipleAssetRequestsStatus = createAction<RequestStatus>(
	'asset/setMultipleAssetRequestsStatus',
);

export const getMultipleAssets = createAction<string[]>(
	'asset/getMultipleAssetsSaga',
);

export const getAssetWithExtendedDataResolved = createAction(
	addNamespace('asset/getAssetWithExtendedData/resolved'),
);
export const getAssetWithExtendedDataRejected = createAction(
	addNamespace('asset/getAssetWithExtendedData/rejected'),
);

export const getSensor = createAction<string>(addNamespace('asset/getSensor'));
export const getSensorResolved = createAction<Asset>(
	addNamespace('asset/getSensor/resolved'),
);
export const getSensorRejected = createAction(
	addNamespace('asset/getSensor/rejected'),
);

export const clearAssets = createAction(addNamespace('asset/clearAssets'));

export const getSystemAssetTypes = createAction(
	addNamespace('asset/getSystemAssetTypes'),
);
export const getSystemAssetTypesResolved = createAction<unknown>(
	addNamespace('asset/getSystemAssetResolved'),
);
export const getSystemAssetTypesRejected = createAction(
	addNamespace('asset/getSystemAssetRejected'),
);
